import React from 'react'

import {
    TablePagination,
} from '@material-ui/core'

import { makeStyles, useTheme } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

import useSingleton from '../../business-components/useSingleton/useSingleton'

import HARDCODE from '../../business-const/HardCode/HardCode'

import LABEL from '../../business-const/Label/Label'

import {
    GridContainerGridItemButtonIncluirLinha
} from '../../business-components/Grid/Grid'



const useStyles1 = makeStyles((theme) => ({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
}));

function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    }
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    }
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    }
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    }
  
    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
}

export const TablePaginationPadrao = ({setFieldValue, list, nameRowsPerPage, namePage, rowsPerPage, page}) => {

    useSingleton(async () => {

        if (!list || (page > Math.trunc(list.length / rowsPerPage))) {

          setFieldValue(namePage, 0)
        }
    })

    const handleChangePage = (event, newPage) => {
        setFieldValue(namePage, newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setFieldValue(nameRowsPerPage, +event.target.value)
        setFieldValue(namePage, 0)
    }

    return (
        list && (list.length / rowsPerPage > 1 || rowsPerPage > HARDCODE.rowsPerPageDefault)
            ?
                <GridContainerGridItemButtonIncluirLinha>
                    <TablePagination
                        className="px-0 bg-white mt-0 mb-0 mr--4"
                        rowsPerPageOptions={[3, 6, 9, 12, 15, 18, 21, 24, 27, 30, 50, 100]}
                        component="div"
                        count={list.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                        labelRowsPerPage={LABEL.MUIDataTablePaginationRowsPerPage}
                        labelDisplayedRows={({ from, to, count }) => {
                            return `${from}-${to} ${LABEL.MUIDataTablePaginationDisplayRows} ${count}`;
                        }}
                    />
                </GridContainerGridItemButtonIncluirLinha>
        :
            ''
    )
}

export const rowPertentePage = (indAux, page, rowsPerPage) => {
    
    return indAux >= (page * rowsPerPage) && indAux < (page * rowsPerPage) + rowsPerPage
}

export const setPageInclusao = (setFieldValue, namePage, list, rowsPerPage) => {
    
    setFieldValue(namePage, Math.trunc(list.length / rowsPerPage))
}

export const setPageExclusao = (setFieldValue, namePage, list, rowsPerPage, page) => {

    if (Math.trunc((list.length - 1) / rowsPerPage) - ((list.length - 1) % rowsPerPage === 0 ? 1 : 0) < page) {

        setFieldValue(namePage, page > 0 ? page - 1 : page)
    }
}
